<div class="text-start align-middle text-xl p-2 h-10 pl-4 leading-5 flex gap-2" *ngIf="internState?.slug" [ngClass]="'bg-'+getSlugText(internState?.slug || '')"> <mat-spinner *ngIf="generating" [diameter]="25"></mat-spinner> {{ 'INTERN.' + (internState ? getSlugText(internState.slug) : "") | uppercase | translate}} </div>
<section class="w-full p-4 h-28 flex flex-col justify-center items-start border-dashed border-b-2">
    <div class="self-end">
        <div class="rejected" *ngIf="this.historyItem.intern?.getLastAssessment() === 'rejected'"> {{ 'VIEW.INTERN_CONTROL_REJECT' | translate }} </div>
        <div class="approved" *ngIf="this.historyItem.intern?.getLastAssessment() === 'approved'"> {{ 'VIEW.INTERN_CONTROL_APPROVED' | translate }}</div>
    </div>
    <div *ngIf="!s_proofreadings.pending.current" class="w-full flex justify-between">
        <div class="">
            <ng-container *ngIf="previousStates?.length">
                <div *ngIf="previousStates && previousStates?.length === 1 ; else selectBlock">
                    <button [disabled]="disabledOnArchived(previousStates[0])" *ngIf="previousCondition(previousStates[0])" mat-flat-button [ngClass]="'bg-'+previousStates[0]" (click)="onPreviousState(previousStates[0])" [matTooltip]="getTooltip(previousStates[0], previousCondition) | translate">
                        <span class="flex items-center gap-1">
                            <mat-icon [ngClass]="'icon-'+getSlugText(previousStates[0])"></mat-icon> <span>{{'INTERN.BTN.PREVIOUS.' + getSlugText(previousStates[0]) | uppercase | translate}}</span>
                        </span>
                    </button>
                </div>
                <ng-template #selectBlock>
                    <button [matMenuTriggerFor]="menu" mat-flat-button class="min-w-fit bg-tw-primary text-tw-text-light">
                        <span>{{ "INTERN.BTN.PREVIOUS.RETURN_TO" | translate }}</span>
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <ng-container *ngFor="let previous of previousStates">
                            <button *ngIf="previousCondition(previous)" [disabled]="disabledOnArchived(previous)" mat-menu-item (click)="onPreviousState(previous)" [matTooltip]="getTooltip(previous, previousCondition) | translate">
                                <div class="flex items-center gap-1">
                                    <div class="w-3 h-3 rounded-xl" [ngClass]="'bg-'+getSlugText(previous)"></div>
                                    <div [ngClass]="getSlugText(previous)">{{'INTERN.BTN.PREVIOUS.' + getSlugText(previous) | uppercase | translate}}</div>
                                </div>
                            </button>
                        </ng-container>
                    </mat-menu>
                </ng-template>
            </ng-container>
        </div>
        <div class="flex flex-row gap-2 ml-2 flex-wrap justify-end" *ngIf="nextStates?.length">
            <ng-container *ngFor="let next of nextStates">
                <button [ngClass]="'bg-'+getSlugText(next)" mat-flat-button [disabled]="!nextCondition(next) || disabledOnArchived(next)" [matTooltipDisabled]="nextCondition(next)" [matTooltip]="getTooltip(next, nextCondition) | translate" (click)="onNextState(next)">
                    <span class="flex items-center gap-1">
                        <mat-icon [ngClass]="'icon-'+getSlugText(next)"></mat-icon>
                        <span>{{'INTERN.BTN.NEXT.' + getSlugText(next) | uppercase | translate}}</span>
                    </span>
                </button>
            </ng-container>
        </div>
    </div>
    <div *ngIf="s_proofreadings.pending.current" class="w-full flex justify-between">
        <ngx-skeleton-loader class="w-[20%] flex gap-2" count="1" [theme]="{ 'height':'40px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader class="w-[40%] flex gap-2" count="2" [theme]="{ 'height':'40px' }"></ngx-skeleton-loader>
    </div>
</section>